import { navigate } from 'gatsby';
import { GatsbyProps } from 'models/gatsby-props';
import { useContext, useRef, useState } from 'react';
import 'react-modern-drawer/dist/index.css';

import { Modal } from '@mui/material';
import logo from 'images/logo.svg';
import { Button, ButtonSize, ButtonVariant } from 'ui';

import { AppStateContext } from 'context/AppContextProvider';
import {
    modal,
    navigationContainer,
    hamburger,
    header,
    darkNav,
    lightNavButton,
    linkActive,
    linkActiveDropdown,
    logoWrapper,
    topNav,
    buttonGroup,
    svgContainer
} from './navbar.module.scss';
import { NavLinks } from './NavLinks';

interface Props extends GatsbyProps {
    isLandingPage?: boolean;
}

export const Navbar = ({ isLandingPage = false, location }: Props) => {
    const headerRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const userState = useContext(AppStateContext);

    const toggleModal = () => {
        setIsOpen(prevState => !prevState);
    };

    const onLogoClick = () => {
        isLandingPage ? window.scroll({ behavior: 'smooth', top: 0 }) : navigate('/');
    };

    return (
        <header ref={headerRef} className={`${header} ${location?.pathname === '/contact' ? darkNav : ''}`}>
            <div className={topNav}>
                <button className={logoWrapper} onClick={onLogoClick}>
                    <img src={logo} alt="elumity logo" />
                </button>
                <nav role="navigation">
                    <NavLinks activeClass={linkActive} />
                </nav>
                <div>
                    <button className={hamburger} onClick={toggleModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                d="M6 8H25M6 16H25M6 24H25"
                                stroke="black"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                    {userState?.loaded &&
                        (userState?.authenticated ? (
                            <a href={`${process.env.GATSBY_ELUMITY_APP_URL}`}>
                                <Button size={ButtonSize.Small} text="Back to Elumity" />
                            </a>
                        ) : (
                            <>
                                <a href={process.env.GATSBY_ELUMITY_APP_URL + '/login'}>
                                    <Button
                                        id={lightNavButton}
                                        size={ButtonSize.Small}
                                        variant={ButtonVariant.Outline}
                                        text="Log in"
                                        resize
                                    />
                                </a>
                                <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup'}>
                                    <Button size={ButtonSize.Small} text="Sign up" />
                                </a>
                            </>
                        ))}
                </div>
            </div>
            <Modal
                open={isOpen}
                onClose={toggleModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{
                    '& .MuiModal-backdrop': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5);'
                    }
                }}>
                <div className={modal}>
                    <div className={navigationContainer}>
                        <nav role="navigation">
                            <NavLinks activeClass={linkActiveDropdown} />
                        </nav>
                        <div className={svgContainer} onClick={toggleModal}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none">
                                <path
                                    d="M11.5335 22.3333L10.3335 21.1333L15.1335 16.3333L10.3335 11.5333L11.5335 10.3333L16.3335 15.1333L21.1335 10.3333L22.3335 11.5333L17.5335 16.3333L22.3335 21.1333L21.1335 22.3333L16.3335 17.5333L11.5335 22.3333Z"
                                    fill="#6B7682"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className={buttonGroup}>
                        {userState?.authenticated ? (
                            <a href={`${process.env.GATSBY_ELUMITY_APP_URL}`}>
                                <Button size={ButtonSize.Big} text="Back to Elumity" />
                            </a>
                        ) : (
                            <>
                                <a href={process.env.GATSBY_ELUMITY_APP_URL + '/login'}>
                                    <Button
                                        id={lightNavButton}
                                        size={ButtonSize.Big}
                                        text="Log in"
                                        variant={
                                            location?.pathname === '/contact'
                                                ? ButtonVariant.Outline
                                                : ButtonVariant.Normal
                                        }
                                    />
                                </a>
                                <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup'}>
                                    <Button size={ButtonSize.Big} text="Sign up" />
                                </a>
                            </>
                        )}
                    </div>
                </div>
            </Modal>
        </header>
    );
};
